const allDataSaved = [];

export const getSaveData = (limit, offset, sort, isMobile) => {
  let foundData;
  foundData = allDataSaved.find(d => d.limit === limit && d.offset === offset && d.sort === sort);
  if (isMobile) {
    if (foundData) {
      const filtered = allDataSaved
        .filter(d => d.offset <= offset && d.sort === sort)
        .sort((a, b) => a.offset > b.offset)
        .reduce(
          (p, c) => {
            return { data: { result: [...p.data.result, ...c.data.result], paging: c.data.paging } };
          },
          { data: { result: [], paging: {} } }
        );

      if (filtered.data.result.length) {
        foundData = filtered;
      }
    }
  }

  if (foundData) {
    return foundData.data;
  }
  return undefined;
};

export const saveData = (limit, offset, sort, data) => {
  if (getSaveData(limit, offset, sort) === undefined) {
    allDataSaved.push({ limit, offset, sort, data });
  }
};

export const updateReadState = leadId => {
  allDataSaved.map(d => {
    d.data.result.map(r => {
      // eslint-disable-next-line eqeqeq
      if (leadId == r.id) {
        r.unread = 0;
      }
      return r;
    });
    return d;
  });
};
